var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "770.0 771.0 1459.0 1459.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1499.5,
    cy: 1500.5,
    r: 729.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1900.03 1362.69C1939.07 1323.63 1939.06 1260.32 1900 1221.27C1860.94 1182.23 1797.62 1182.24 1758.58 1221.31L1412.48 1567.56L1239.71 1394.79C1200.66 1355.74 1137.34 1355.74 1098.29 1394.79C1059.24 1433.84 1059.24 1497.16 1098.29 1536.21L1341.79 1779.71C1360.55 1798.47 1385.99 1809 1412.51 1809C1439.04 1809 1464.48 1798.45 1483.23 1779.69L1900.03 1362.69Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/1779176049/media/icon-check-circle.307b39edb733cb8d107f17e6db94ae52.svg";
export { ForwardRef as ReactComponent };